import React from 'react';
import { Box } from '@mui/material';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import PersonIcon from '@mui/icons-material/Person';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { useTransportDataStyles } from './FuelProvisionalConfirm.styles';

const TransportData = ({ transport }) => {
  const classes = useTransportDataStyles();
  const vehicleLabel = transport?.vhc_imm || transport?.rent_type || '—';
  const consumptionLabel =
    transport?.vhc_conso_100km !== null && transport?.vhc_conso_100km !== undefined
      ? `${transport.vhc_conso_100km} L`
      : '—';
  const priceLabel =
    transport?.price_per_liter !== null && transport?.price_per_liter !== undefined
      ? `${transport.price_per_liter} Ar/L`
      : '—';

  const summaryItems = [
    { label: 'Voiture', value: vehicleLabel, icon: <DirectionsCarIcon /> },
    { label: 'Chauffeur', value: transport?.driver_name || '—', icon: <PersonIcon /> },
    { label: 'Chef de bord', value: transport?.captain_name || '—', icon: <SupervisorAccountIcon /> },
    { label: 'Consommation à 100 km', value: consumptionLabel, icon: <LocalGasStationIcon /> },
    { label: 'Prix unitaire', value: priceLabel, icon: <LocalOfferIcon /> },
  ];

  return (
    <Box className={classes.grid}>
      {summaryItems.map((item) => (
        <Box className={classes.card} key={item.label}>
          <Box className={classes.icon}>{item.icon}</Box>
          <Box>
            <Box className={classes.label}>{item.label}</Box>
            <Box className={classes.value}>{item.value}</Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default TransportData;